







import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { EssenceItemDto } from '@eurogast/hub-client-typescript';
import EssenceDropdown from '@/common/EssenceDropdown.vue';
import { BooleanService } from '@/services/util/BooleanService';

@Component({
  components: {EssenceDropdown}
})
export default class EssenceDropdownTh extends Vue {
  @Prop({ required: true })
  public localEssences: string;

  @Prop({ required: false })
  public localHighlighted: string;

  get essenceList(): EssenceItemDto[] {
    return ConfigService.parseEssence(this.localEssences);
  }

  get highlighted(): boolean {
    return BooleanService.fromString(this.localHighlighted);
  }

}
